import { render, staticRenderFns } from "./traderLogin.vue?vue&type=template&id=0aeb3480&scoped=true"
import script from "./traderLogin.vue?vue&type=script&lang=js"
export * from "./traderLogin.vue?vue&type=script&lang=js"
import style0 from "./traderLogin.vue?vue&type=style&index=0&id=0aeb3480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb3480",
  null
  
)

export default component.exports